<template>
  <div class="transition">
    <BasicText size="h5">Disposez-vous d’un mandat de gestion au nom de l’entreprise ?</BasicText>
    <div class="transition-items">
      <BasicCheckbox
        label=" Oui je dispose du mandat de gestion"
        @update:model-value="sousMandat = true"
        :model-value="sousMandat === true"
      />
      <BasicCheckbox
        label="Non je ne dispose pas de mandat de gestion"
        @update:model-value="sousMandat = false"
        :model-value="sousMandat === false"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'

  const props = defineProps<CarteProps<void, boolean>>()
  const emits = defineEmits<CarteEvents<boolean>>()

  const sousMandat = computed({
    get: () => props.out,
    set: (value) => emits('outChanged', true, value),
  })
</script>
<style lang="less" scoped>
  @import './ChoixCarte.less';
</style>
